module.exports = __webpack_public_path__ + "static/media/bg-left.cacdb10a.svg";